import React from "react";
import styles from "./Header.Resume.module.scss";
import { useNavigate } from "react-router-dom";
import { MdArrowBackIosNew } from "react-icons/md";
import { RiLayoutGridFill } from "react-icons/ri";

function HeaderResume() {
  const navigate = useNavigate();

  return (
    <div className={styles.header}>
      <div className={styles.headerBack} onClick={() => navigate(-1)}>
        <MdArrowBackIosNew size={25} />
      </div>

      <div className={styles.space}></div>

      <button
        onClick={() => navigate("/profile")}
        className={styles.headerProfile}
      >
        <RiLayoutGridFill size={25} />
      </button>
    </div>
  );
}

export default HeaderResume;